import React, { useState } from "react";
import { Modal, Button, Form, Input, Select } from "antd";
import { createRole } from "../../../redux/Roles/actions";
import { useDispatch, useSelector } from "react-redux";

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

export const AddRoleButton = () => {
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();
  const capabilities = useSelector((state) => state.capabilities.capabilities);
  const resources = useSelector((state) => state.resources.resources);

  const showModal = () => {
    setVisible(true);
  };

  const hideModal_Ok = () => {
    form.submit();
  };

  const form_onfinish = () => {
    let data = form.getFieldsValue();
    dispatch(createRole(data));
    form.resetFields();
    setVisible(false);
  };

  const hideModal_Cancel = () => {
    setVisible(false);
    form.resetFields();
  };

  return (
    <>
      <Button type="primary" onClick={showModal}>
        + Role
      </Button>
      <Modal
        title="Add Role"
        visible={visible}
        onOk={hideModal_Ok}
        onCancel={hideModal_Cancel}
        okText="Submit"
        cancelText="Close"
      >
        <Form
          {...layout}
          name="basic"
          form={form}
          onFinish={form_onfinish}
          initialValues={{ remember: false }}
        >
          <Form.Item
            label="Role Name"
            name="name"
            rules={[{ required: true, message: "Please enter the role name!" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Default Capabilities"
            name="defaultCapabilities"
          >
            <Select mode="multiple" placeholder="Select default capabilities">
              {capabilities.map((capability) => (
                <Select.Option key={capability._id} value={capability._id}>
                  {capability.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="Default Resources"
            name="defaultResources"
          >
            <Select mode="multiple" placeholder="Select default resources">
              {resources.map((resource) => (
                <Select.Option key={resource._id} value={resource._id}>
                  {resource.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default AddRoleButton;
